import { Component, OnInit } from '@angular/core';
import { PolicyContextService } from '@benefitsui/app/services/policy-context/policy-context.service';

@Component({
  selector: 'app-allforms-page',
  templateUrl: './forms-page.component.html',
  styleUrls: ['./forms-page.component.scss'],
  providers: [PolicyContextService]
})

export class AllFormsPageComponent implements OnInit {
  constructor(
  ) {}

  ngOnInit(): void {             
  }
}
